import React, { useState, useEffect } from 'react'
import TodosItem from '../components/todoItem';

export default function Todos(props){
/*const completedTasks = props.todos.filter(todo => todo.isCompleted);
const activeTasks = props.todos.filter(todo => !todo.isCompleted);*/
  // tasks
  const [active, setActive] = useState([]);
  const [completed, setCompleted] = useState([]);

  useEffect(() => {
    const activeTodos = props.todos.filter(todo => !todo.isComplete);
    const completedTodos = props.todos.filter(todo => todo.isComplete);

    setActive(activeTodos);
    setCompleted(completedTodos);
  }, [props.todos]);
  const [val, setVal] = useState("");
  return(
    <>
<div className="container mt-3">
  <div className="d-flex"> 
  <input 
        type="text" 
        className="form-control me-2" 
        placeholder="Enter a new task"
        value={val}                       // input shows what's in val
        onChange={(e) => setVal(e.target.value)}  // updates val on typing
      />

    <button onClick={()=>{props.addTask(val) ;setVal("");}} className="add btn btn-primary">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
</svg>
    </button>
  </div>
</div>
      <div className="container mt-5">
  {/* Nav tabs */}
  <ul className="nav nav-tabs" id="myTab" role="tablist">
    <li className="nav-item" role="presentation">
      <button className="nav-link active" id="tab1-tab" data-bs-toggle="tab" data-bs-target="#tab1" type="button" role="tab">All</button>
    </li>
    <li className="nav-item" role="presentation">
      <button className="nav-link" id="tab2-tab" data-bs-toggle="tab" data-bs-target="#tab2" type="button" role="tab">Active</button>
    </li>
    <li className="nav-item" role="presentation">
      <button className="nav-link" id="tab3-tab" data-bs-toggle="tab" data-bs-target="#tab3" type="button" role="tab">Completed</button>
    </li>
  </ul>

  {/* Tab panes */}
  
  <div className="tab-content p-3 border border-top-0" id="myTabContent" style={{
  maxHeight: "50vh",
  overflow: "scroll",
  scrollbarWidth: "none", /* Firefox */
  msOverflowStyle: "none" /* IE and Edge */
}}>
    <div className="tab-pane fade show active" id="tab1" role="tabpanel">
    {
      props.todos.length === 0 ? 
      <p className="text-center">No tasks yet. Add one above!</p> 
      :
      props.todos.map((todo, index) => (
        <TodosItem 
          todo={todo}
          onDelete={props.onDelete}
          toggleCompleted={props.toggleCompleted}
          index={index}
          Completed={todo.isComplete}
        />
      ))
    }
    </div>
    <div className="tab-pane fade" id="tab2" role="tabpanel">
    {
      active.length === 0 ? 
      <p className="text-center">No active tasks.</p> 
      :
      active.map((todo, index) => (
        <TodosItem 
          todo={todo}
          onDelete={props.onDelete}
          toggleCompleted={props.toggleCompleted}
          index={index}
          Completed={todo.isComplete}
        />
      ))
    }
    </div>
    <div className="tab-pane fade" id="tab3" role="tabpanel">
    {
      completed.length === 0 ? 
      <p className="text-center">No completed tasks.</p> 
      :
      completed.map((todo, index) => (
        <TodosItem 
          todo={todo}
          onDelete={props.onDelete}
          toggleCompleted={props.toggleCompleted}
          index={index}
          Completed={todo.isComplete}
        />
      ))
    }
    </div>
  </div>
</div>
</>
    )
}